import { render, staticRenderFns } from "./CatalogTableMain.vue?vue&type=template&id=1ef462f6"
import script from "./CatalogTableMain.vue?vue&type=script&lang=js"
export * from "./CatalogTableMain.vue?vue&type=script&lang=js"
import style0 from "./CatalogTableMain.vue?vue&type=style&index=0&id=1ef462f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports